import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "col-12",
  style: {"background-color":"#414e70"}
}
const _hoisted_2 = {
  class: "panelep col-4",
  style: {"display":"flex","align-items":"center","justify-content":"center"}
}
const _hoisted_3 = { class: "labeltitle" }
const _hoisted_4 = {
  class: "labeltitle",
  style: {"width":"85%"}
}
const _hoisted_5 = {
  class: "row",
  style: {"display":"flex"}
}
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"row\"><div class=\"separator2\"></div><div class=\"separator2\"></div><div class=\"separator\"></div><div class=\"separator\"></div></div>", 1)
const _hoisted_14 = {
  class: "pagefoot col-12",
  style: {"background-color":"#414e70","height":"100px"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-circle-right" }, null, -1)

import { onMounted, ref } from "vue";
import { useStore } from 'vuex';

import UsersEdit from "../components/users/UsersEdit.vue";
import UsersFilter from "../components/users/UsersFilter.vue";

interface User {
    UserName: string;
    Signature: string;
    Rights: number;
    TransSyntax: number;
    PrinterAET: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UsersPage',
  setup(__props) {

const store = useStore();

var results = ref<User[]>([]);
var editModal = ref(false);
var filterModal = ref(false);
var selectedUser = ref(null);
var valueToSearch = "";

function closeModal() {
    selectedUser.value = null;
    editModal.value = false;
    filterModal.value = false;
    getUsers("");
}

function openAddNewDialog() {
    selectedUser.value = null;
    editModal.value = true;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function openEditDialog(user: any) {
    selectedUser.value = user;
    editModal.value = true;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function openFilterDialog(user: any) {
    selectedUser.value = user;
    filterModal.value = true;
}

async function sendDelete(id: string) {
    const result = await store.dispatch('HTTPDelete', { url: "users/", id: id });
    alert(result);
    getUsers("");
}

function getTransSyntax(index:number) {
    var list_TransSyntax = "";

    switch (index) {
        case 0: list_TransSyntax = "LE Explicit";
            break;
        case 1: list_TransSyntax = "JPEG Lossless";
            break;
        case 2: list_TransSyntax = "JPEG Lossy";
            break;
        case 3: list_TransSyntax = "JPEG 2K Lossless";
            break;
        case 4: list_TransSyntax = "JPEG 2K Lossy";
            break;
    }
    return list_TransSyntax;
}

function getRole(index: number) {
    var list_Role = "";

    switch (index) {
        case 0: list_Role = "General";
            break;
        case 1: list_Role = "Admin";
            break;
        case 2: list_Role = "Radiologist";
            break;
        case 3: list_Role = "Referring";
            break;
        case 4: list_Role = "Manager";
            break;
    }
    return list_Role;
}

async function getUsers(id: string) {
    var url = "users";

    if (id != undefined) {
        if (id.length != 0) {
            url = url + "/" + id;
        } else {
            valueToSearch = "";
        }
    } else {
        valueToSearch = "";
    }
    results.value = await store.dispatch("HTTPGet", { url: url });
    console.log("getUsers", results.value);
}

onMounted(async () => {
    getUsers("");
})

return (_ctx: any,_cache: any) => {
  const _component_nav_bar = _resolveComponent("nav-bar")!
  const _component_footer_bar = _resolveComponent("footer-bar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_nav_bar, {
      title: _ctx.$t('UserPage.UserManagement')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("UserPage.SearchUser")), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            style: {"width":"85%"},
            placeholder: "...",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(valueToSearch) ? (valueToSearch).value = $event : valueToSearch = $event))
          }, null, 512), [
            [_vModelText, _unref(valueToSearch)]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "okbtn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (getUsers(_unref(valueToSearch))))
          }, _toDisplayString(_ctx.$t("UserPage.Query")), 1),
          _createElementVNode("button", {
            class: "cnlbtn",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (getUsers('')))
          }, _toDisplayString(_ctx.$t("UserPage.Reset")), 1)
        ])
      ])
    ]),
    (_unref(results))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", null, [
            _createElementVNode("table", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("UserPage.User")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("UserPage.Signature")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("UserPage.Rights")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("UserPage.TSyntax")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("UserPage.Printer")), 1),
                _hoisted_7,
                _hoisted_8,
                _hoisted_9
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(results), (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.UserName
                }, [
                  _createElementVNode("td", null, _toDisplayString(item.UserName), 1),
                  _createElementVNode("td", null, _toDisplayString(item.Signature), 1),
                  _createElementVNode("td", null, _toDisplayString(getRole(item.Rights)), 1),
                  _createElementVNode("td", null, _toDisplayString(getTransSyntax(item.TransSyntax)), 1),
                  _createElementVNode("td", null, _toDisplayString(item.PrinterAET), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("button", {
                      class: "okbtn",
                      onClick: ($event: any) => (openEditDialog(item)),
                      style: {"width":"60px"}
                    }, _toDisplayString(_ctx.$t("Common.Edit")), 9, _hoisted_10)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("button", {
                      class: "okbtn",
                      onClick: ($event: any) => (openFilterDialog(item)),
                      style: {"width":"60px"}
                    }, _toDisplayString(_ctx.$t("UserPage.Filter")), 9, _hoisted_11)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("button", {
                      class: "cnlbtn",
                      onClick: ($event: any) => (sendDelete(item.UserName)),
                      style: {"width":"60px"}
                    }, _toDisplayString(_ctx.$t("Common.Delete")), 9, _hoisted_12)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_13,
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("button", {
        onClick: openAddNewDialog,
        style: {"float":"right"},
        class: "okbtn"
      }, [
        _hoisted_15,
        _createTextVNode(_toDisplayString(_ctx.$t("Common.AddNew")), 1)
      ])
    ]),
    (_unref(editModal))
      ? (_openBlock(), _createBlock(UsersEdit, {
          key: 1,
          onClose: closeModal,
          selectedUser: _unref(selectedUser)
        }, null, 8, ["selectedUser"]))
      : _createCommentVNode("", true),
    (_unref(filterModal))
      ? (_openBlock(), _createBlock(UsersFilter, {
          key: 2,
          onClose: closeModal,
          selectedUser: _unref(selectedUser)
        }, null, 8, ["selectedUser"]))
      : _createCommentVNode("", true),
    _createVNode(_component_footer_bar, {
      title: _ctx.$t('UserPage.UserManagement')
    }, null, 8, ["title"])
  ], 64))
}
}

})